"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = rootSaga;
var _effects = require("redux-saga/effects");
var _session = _interopRequireDefault(require("./session"));
var _appconfig = _interopRequireDefault(require("./appconfig"));
var _menu = _interopRequireDefault(require("./menu"));
var _notifications = _interopRequireDefault(require("./notifications"));
var _ws = _interopRequireDefault(require("./ws"));
var _ua = _interopRequireDefault(require("./ua"));
var _context = _interopRequireDefault(require("./context"));
function* rootSaga() {
  yield (0, _effects.all)([(0, _session.default)(), (0, _appconfig.default)(), (0, _menu.default)(), (0, _notifications.default)(), (0, _ws.default)(), (0, _ua.default)(), (0, _context.default)()]);
}